import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Eye } from 'lucide-react';
import { ResumeThumb } from './ResumeThumb';
import { track } from '../../lib/analytics';

export const TemplateCard = ({ tpl, onUse, useLabel = 'Use Template', compact = false }) => (
  <article data-testid={`template-card-${tpl.id}`} className="group flex h-full flex-col overflow-hidden rounded-2xl border border-border bg-white transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-[0_24px_48px_-24px_rgba(16,24,40,0.3)]">
    <Link to={`/templates/${tpl.id}`} onClick={() => track('template_view', { template_id: tpl.id })} aria-label={`Preview ${tpl.name} template`} className="relative block bg-[#EEF1F5] p-4 pb-0">
      <ResumeThumb templateId={tpl.id} accent={tpl.accent} india={tpl.id === 'indian'} className="rounded-t-md shadow-md ring-1 ring-black/5" maxHeight={compact ? 240 : 300} />
      {tpl.ats_friendly && (
        <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-full bg-white/95 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-emerald-700 shadow-sm ring-1 ring-emerald-100"><ShieldCheck className="h-3 w-3" aria-hidden="true" /> ATS-friendly</span>
      )}
      <span className="absolute inset-x-0 bottom-0 flex justify-center pb-3 opacity-0 transition-opacity duration-200 group-hover:opacity-100"><span className="inline-flex items-center gap-1 rounded-full bg-primary px-3 py-1.5 text-xs font-semibold text-white"><Eye className="h-3.5 w-3.5" aria-hidden="true" /> Preview</span></span>
    </Link>
    <div className="flex flex-1 flex-col p-5">
      <div className="flex items-start justify-between gap-2">
        <div>
          <h3 className="text-base font-bold text-primary">{tpl.name}</h3>
          <p className="mt-0.5 text-xs text-muted-foreground">{tpl.category}</p>
        </div>
      </div>
      {!compact && tpl.best_for && <p className="mt-2 text-xs text-muted-foreground">Good for: {tpl.best_for.join(' · ')}</p>}
      <div className="mt-4 flex gap-2">
        <Link to={`/templates/${tpl.id}`} data-testid={`template-preview-${tpl.id}`} className="inline-flex min-h-[40px] flex-1 items-center justify-center rounded-full border border-border px-3 text-sm font-semibold text-primary hover:border-primary/30">Preview</Link>
        <button type="button" data-testid={`template-use-${tpl.id}`} onClick={() => onUse(tpl)} className="inline-flex min-h-[40px] flex-1 items-center justify-center rounded-full bg-primary px-3 text-sm font-semibold text-white transition-colors hover:bg-primary/90">{useLabel}</button>
      </div>
    </div>
  </article>
);

// Horizontal snap-scroll on mobile, grid on desktop.
export const TemplateGallery = ({ templates, onUse, compact = false }) => (
  <div className="-mx-5 flex snap-x snap-mandatory gap-4 overflow-x-auto px-5 pb-2 no-scrollbar sm:mx-0 sm:grid sm:grid-cols-2 sm:overflow-visible sm:px-0 lg:grid-cols-3" data-testid="template-gallery">
    {templates.map((tpl) => (
      <div key={tpl.id} className="w-[78vw] shrink-0 snap-center sm:w-auto"><TemplateCard tpl={tpl} onUse={onUse} compact={compact} /></div>
    ))}
  </div>
);
